<template>
  <div class="password-main-container">
    <div class="password-box">
      <div class="forget-title">Create New Password</div> 
      <div class="forget-description">Please enter your email address</div> 
      <el-form
        label-width="0px"
        :model="userspasswordData"
        :rules="passwordFormRules"
        ref="passwordForm"
      >
        <el-form-item
          label="Email"
          prop="email"
        >
          <el-input v-model="userspasswordData.email"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="create-button">
      <el-button @click="send">Create Password</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Password",
  data() {
    return {
      userspasswordData: {
        email: "",
      },
      passwordFormRules: {
        email: [
          { required: true, message: "Enter E-mail address", trigger: "blur" },
          {
            type: "email",
            message: "Enter correct E-mail address",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    send() {
      this.$refs.passwordForm.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$http.post(
          "/forgot",
          this.userspasswordData
        );
        if (res.status !== 200)
          return this.$message({
            type: "warning",
            message: "Couldn't find your account or wrong password",
          });
        this.$message({
          type: "success",
          message: "Please Check Your Email",
        });
        location.href='https://pawaiipets.com/admin/#/login'
      });
    },
  },
};
</script>

<style scoped>
.password-main-container {
  color: #1a1a1a;
  width: 600px;
  margin: 0 auto;
  position: relative;
  margin-top: 248px;
}
.forget-title {
  font-weight: 600;
  text-align: center;
  font-size: 50px;
  line-height: 75px;
  font-family: Poppins-SemiBold;
  padding-bottom: 20px;
}
.forget-description {
  width: 400px;
  margin: 0 auto;
  text-align: center;
  font-weight: normal;
  font-size: 18px;
  line-height: 27px;
  font-family: Poppins-Regular;
  padding-bottom: 77px;
}
.el-form {
  width: 400px;
  margin: 0 auto;
}
.el-form >>> label {
  font-weight: normal;
  color: #1a1a1a;
  font-size: 24px;
  line-height: 36px;
  font-family: Poppins-Regular;
}
.el-input >>> input {
  border-bottom: 1px solid #000;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
  border-radius: 0;
}
.create-button {
  width: 400px;
  margin: 0 auto;
}
.create-button .el-button {
  margin-top: 18px;
  width: 400px;
  height: 60px;
  text-align: center;
  font-family: Poppins-Regular;
  font-weight: normal;
  font-size: 18px;
  line-height: 27px;
  background-color: #ff5349;
  color: #ffffff;
}
@media screen and (min-width: 768px) and (max-width: 1109px) {
  .forget-title {
    width: 500px;
    margin: 0 auto;
    font-size: 40px;
    line-height: 60px;
    padding-bottom: 30px;
  }
  .forget-description {
    padding-bottom: 80px;
  }
}
@media screen and (max-width: 767px) {
  .password-main-container {
    margin-top: 122px;
    width: 300px;
  }
  .forget-title {
    width: 300px;
    font-size: 24px;
    line-height: 36px;
    padding-bottom: 10px;
  }
  .forget-description {
    width: 300px;
    font-size: 12px;
    line-height: 18px;
    padding-bottom: 40px;
  }
  .el-form >>> label {
    font-size: 15px;
    line-height: 22px;
  }
  .el-form {
    width: 300px;
  }
  .create-button {
    width: 300px;
  }
  .create-button .el-button {
    width: 300px;
    height: 50px;
    font-size: 15px;
    line-height: 22px;
  }
}
</style>